import { Container, List, ListItem, styled, Typography } from '@mui/material';
import React from 'react';

import dealGPTSplashImage from '../../../assets/dealgpt-splash-image.jpg';

const NoAccessContainer = styled(Container)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '24px',
  backgroundColor: '#ffffff',
  margin: 'auto',
  padding: '24px',
});

const BulletedListItem = styled(ListItem)({
  display: 'list-item',
  paddingLeft: 2,
});

const ListTypography = styled(Typography)({
  fontSize: '18px',
});

const NoAccess = (): JSX.Element => (
  <NoAccessContainer>
    <Typography variant="h4" sx={{ fontWeight: 600, textAlign: 'center' }}>
      Intellio® Advantage combines multiple assets into one powerful Generative AI Asset
    </Typography>
    <img src={dealGPTSplashImage} alt="DealGPT Splash Image" width="100%" />
    <Typography variant="h6" sx={{ textAlign: 'center', width: '90%' }}>
      {`Using Nigel's secure environment, we can build any custom user interface to snap to our
      processes within West Monroe.`}
    </Typography>
    <div style={{ width: '90%' }}>
      <List sx={{ listStyleType: 'disc' }}>
        <BulletedListItem>
          <ListTypography>
            To get started learning about Intellio Advantage, check out our{' '}
            <a
              href="https://howto.westmonroe.com/a/1972114-welcome-to-the-intellio-advantage-help-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              How-to Guide
            </a>
          </ListTypography>
        </BulletedListItem>
        <BulletedListItem>
          <ListTypography>
            Want to add your project to Intellio Advantage?{' '}
            <a
              href="https://howto.westmonroe.com/a/1805084"
              target="_blank"
              rel="noopener noreferrer"
            >
              Find out how here
            </a>
            .
          </ListTypography>
        </BulletedListItem>
      </List>
    </div>
  </NoAccessContainer>
);

export default NoAccess;
